export const DEFAULT_VALUES = {
  areaatuacao: '',
  moduloatuacao: '',
  nivel: '',
  projetos_executados: 0,
  valor_hora: '',
}
